// src/components/PublicCpts/Styles/Signup.Style.js
// @flow

import { phoneInputCss } from '../../../css/phoneInput';

/**
 * This file defines an object of style keys. 
 * Each key is a function `(theme) => ({ ... })` returning style objects.
 * We'll call `createClasses(signupStyles, theme)` in `Signup.js` to get final style objects.
 */

const signupStyles = {
  headerLogo: (theme) => ({
    marginTop: 30,
    marginBottom: 30,
    textAlign: 'center'
  }),
  headerConnectLogo: (theme) => ({
    display: 'flex',
    marginTop: 30,
    marginBottom: 30,
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center'
  }),
  paperCtr: (theme) => ({
    padding: theme.spacing(2),
    paddingBottom: theme.spacing(4)
  }),
  spacedPlus: (theme) => ({
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2)
  }),
  formErrorResponse: (theme) => ({
    color: theme.palette.error.main,
    marginBottom: theme.spacing(2),
    textAlign: 'center',
    fontSize: '1rem'
  }),
  formSubmitBtnErrorResponse: (theme) => ({
    color: theme.palette.error.main,
    marginBottom: -theme.spacing(1),
    marginTop: theme.spacing(2),
    textAlign: 'center',
    fontSize: '1rem'
  }),
  connectContentCtr: (theme) => ({
    position: 'relative',
    maxWidth: 600,
    paddingTop: 30,
    paddingLeft: 20,
    paddingRight: 20,
    margin: '0 auto',
    textAlign: 'left',
    zIndex: 0
  }),
  contentCtr: (theme) => ({
    position: 'relative',
    maxWidth: 540,
    paddingTop: theme.spacing(8),
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    margin: '0 auto',
    textAlign: 'left',
    zIndex: 0
  }),
  formTitle: (theme) => ({
    textAlign: 'center',
    marginBottom: theme.spacing(1.5),
    fontWeight: theme.typography.fontWeightBold
  }),
  formSubtitle: (theme) => ({
    textAlign: 'center',
    marginBottom: theme.spacing(4),
    color: theme.palette.text.secondary,
    fontSize: '1.05rem',
    lineHeight: 1.4
  }),
  trialReassurance: (theme) => ({
    textAlign: 'center',
    marginTop: theme.spacing(1.5),
    color: theme.palette.text.primary,
    fontSize: '0.9rem',
    fontWeight: 500
  }),
  signInPrompt: (theme) => ({
    textAlign: 'center',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(4),
    color: theme.palette.text.secondary,
    fontSize: '0.9rem'
  }),
  signInLink: (theme) => ({
    color: theme.palette.primary.main,
    textDecoration: 'underline',
    fontWeight: 600
  }),
  inputForm: (theme) => ({
    backgroundColor: 'white',
    borderRadius: 0,
    padding: `${theme.spacing(2)}px 30px`,
    minWidth: '100%',
    textAlign: 'left',
    margin: 0,
    fontSize: '1rem',
    '&::placeholder': {
      color: '#a3c2d9'
    }
  }),
  newInputForm: (theme) => ({
    width: '100%',
    borderRadius: 4,
    margin: '4px 0px',
    backgroundColor: 'white',
    '& input': {
      paddingTop: '1.5rem',
      paddingBottom: '1.5rem',
      textAlign: 'left',
      margin: 0,
      border: 0,
      '&::placeholder': {
        color: theme.palette.text.secondary,
        opacity: 0.6
      }
    }
  }),
  phoneContainer: (theme) => ({
    border: '1px solid rgba(0, 0, 0, 0.23)',
    '& .react-phone-number-input__phone': {
      fontSize: '1rem',
      borderBottom: '0px !important'
    },
    '& .react-phone-number-input__row': {
      padding: `2px 14px 16px 14px`
    }
  }),
  phoneInputCtr: (theme) => ({
    ...phoneInputCss
  }),
  formElt: (theme) => ({
    borderTop: 0,
    borderRight: '1px #B4CEE1 solid',
    borderLeft: '1px #B4CEE1 solid',
    borderBottom: '1px #B4CEE1 solid',
    outline: 0,
    '&:first-of-type': {
      borderTop: '1px #B4CEE1 solid'
    }
  }),
  newFormElt: (theme) => ({
    width: '100%',
    outline: 0,
    borderRadius: 'inherit'
  }),
  checkboxCtr: (theme) => ({
    margin: '16px 0px 4px 0px',
    '& span': {
      background: 'transparent',
      margin: 0,
      fontSize: '0.9rem'
    }
  }),
  checkbox: (theme) => ({
    '& span': {
      margin: '4px 4px 4px 4px'
    }
  }),
  errorLabel: (theme) => ({
    marginLeft: theme.spacing(0),
    marginBottom: theme.spacing(1),
    color: theme.palette.error.main,
    textAlign: 'left'
  }),
  signin: (theme) => ({
    width: '100%',
    borderRadius: 4,
    fontWeight: 600,
    padding: `${theme.spacing(2)}px 30px`
  }),
  signupBtn: (theme) => ({
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
    width: '100%',
    borderRadius: 8,
    fontWeight: theme.typography.fontWeightBold,
    fontSize: '1.15rem',
    textTransform: 'none',
    padding: `${theme.spacing(3)} 30px`,
    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.15)'
  }),
  helpLink: (theme) => ({
    marginTop: theme.spacing(2),
    textAlign: 'center',
    textDecoration: 'underline',
    fontSize: '0.8rem'
  }),
  captchaCtr: (theme) => ({
  })
};

export default signupStyles;